module.exports = __webpack_public_path__ + "media/Philippe  Nonie - Carnet d esprit - Autre Histoire Tchernobyl.89e7fde5.mp3";